import React, { useEffect } from "react";
export interface ITimer {
  min: number;
  sec: number;
  onTimerClose: Function;
  timerState?: boolean;
}
const Timmer = (props: ITimer) => {
  const [timer, setTimer] = React.useState({
    min: props.min,
    sec: props.sec,
  });

  useEffect(() => {
    if (props?.timerState) {
      setTimer({
        min: props.min,
        sec: props.sec,
      });
    }
  }, [props?.timerState]);

  React.useEffect(() => {
    const intervalId = setInterval(function () {
      countDown(timer.min, timer.sec, setTimer);
    }, 1000);

    if (timer.min === 0 && timer.sec === 0) {
      clearInterval(intervalId);
      props?.onTimerClose(true);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);
  return (
    <>
      <div className="timer ps-1">
        <span>0{timer.min}</span>

        <span>:</span>

        <span>{timer.sec > 9 ? timer.sec : "0" + timer.sec}</span>
      </div>
    </>
  );
};

export function countDown(min: number, sec: number, cb: Function) {
  if (sec === 0 && min !== 0) {
    return cb({ min: min - 1, sec: 59 });
  } else if (sec > 0) {
    if (sec > 10) {
      return cb({ min: min, sec: sec - 1 });
    } else {
      return cb({ min: min, sec: sec - 1 });
    }
  }
}

export default Timmer;
